import { useAtom, useAtomValue } from 'jotai';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { activeConversationIdAtom, preApproveCardShowAtom } from '../store';

export default function usePreApproveCardShow() {
  const [preApproveCardShow, setPreApproveCardShow] = useAtom(preApproveCardShowAtom);
  const activeConversationId = useAtomValue(activeConversationIdAtom);

  useEffect(() => {
    // TODO refactor to atom with storage
    const preApprovals = JSON.parse(window.localStorage.getItem('preApprovals')) || {};
    const currentPreApproval = preApprovals[activeConversationId];
    if (currentPreApproval) {
      const timeDiff = dayjs().diff(dayjs(currentPreApproval), 'hour', true);
      if (timeDiff >= 24) {
        setPreApproveCardShow(true);
      } else {
        setPreApproveCardShow(false);
      }
    }
  }, [activeConversationId]);

  const hidePreApproveBox = () => {
    setPreApproveCardShow(false);
    const data = JSON.parse(window.localStorage.getItem('preApprovals')) || {};
    data[activeConversationId] = new Date();
    window.localStorage.setItem('preApprovals', JSON.stringify(data));
  };

  return [preApproveCardShow, hidePreApproveBox] as [boolean, () => void];
}
